<template>
  <div class="">
    <!-- 任務三塊，僅大螢幕顯示 -->
    <div class="d-none d-lg-block">
      <div class="row px-2">
        <div
          v-for="task in taskCardItem"
          class="col"
          :class="task.title === 'Assignment' ? 'col-md-5' : ' col'"
        >
          <div
            @click="$goPage(task.link)"
            class="card mission pointer my-auto"
            :class="
              userCustomization.userGroup === 'B2C'
                ? 'b2c-min-card-height'
                : 'min-card-height'
            "
            :style="[
              { backgroundImage: `url(${task.bg})` },
              { backgroundColor: task.bgColor },
            ]"
          >
            <div class="card-body">
              <div class="text-white strong my-2 m-text">{{ task.title }}</div>

              <span
                v-if="
                  task.hint !== '' &&
                  task.hint !== null &&
                  task.hint !== undefined
                "
                class="hint badge badge-danger rounded-circle p-0 font-size-12"
                >{{ task.hint }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END 任務三塊，僅大螢幕顯示 -->
    <!-- 任務三塊，平板以下顯示 -->
    <div class="row d-lg-none d-flex justify-content-center">
      <div class="col-11 col-sm-12 px-0" v-for="task in taskCardItem">
        <!-- position-relative -->
        <div
          @click="$goPage(task.link)"
          class="card mission position-relative pointer"
          :class="
            userCustomization.userGroup === 'B2C'
              ? 'b2c-min-card-height'
              : 'min-card-height'
          "
          :style="[
            { backgroundImage: `url(${task.bg})` },
            { backgroundColor: task.bgColor },
          ]"
        >
          <div class="card-body col-sm-12">
            <h4 class="text-white my-1 text-white font-weight-bold m-text">
              {{ task.title }}
            </h4>
            <a>
              <span
                v-if="
                  task.hint !== '' &&
                  task.hint !== null &&
                  task.hint !== undefined
                "
                class="hint badge badge-danger rounded-circle p-0 font-size-12"
                >{{ task.hint }}</span
              ></a
            >
          </div>
        </div>
      </div>
    </div>
    <!-- END 任務三塊，僅手機顯示 -->
  </div>
</template>
<script setup>
import { useUserInfoStore } from "@/store/modules/userInfo";
import { useUserCustomizationStore } from "@/store/modules/userCustomization";
import { useI18n } from "vue-i18n";
import { ApiGetAISpeechList } from "@/service/apis/aispeech.js";
import { ApiDailySpeechGetQuiz } from "@/service/apis/dailyAispeech.js";

const { locale, t } = useI18n({
  inheritLocale: true,
});
const $goPage = inject("$goPage");
const user = useUserInfoStore();
const userCustomization = useUserCustomizationStore();

// AI Speech 任務數量
const aiSpeechCount = ref(0);
const dailySpeechCount = ref(0);

const imgTeacher = computed(() => {
  return new URL(`../assets/img/images/teacher.svg`, import.meta.url).href;
});

const imgMoutain = computed(() => {
  return new URL(`../assets/img/images/moutain.svg`, import.meta.url).href;
});
const imgTrophy = computed(() => {
  return new URL(`../assets/img/images/trophy.svg`, import.meta.url).href;
});

// 獲取 Daily Speech 任務數量
const getDailySpeechCount = async () => {
  try {
    if (user.student && user.student.stuID) {
      const response = await ApiDailySpeechGetQuiz.get(user.student.stuID);
      console.log("Daily Speech Quiz 回應:", response);

      if (response.status === "success" && response.data) {
        // 檢查 sentences 中是否有 score 為 null 的
        const hasIncomplete = response.data.sentences?.some(
          (sentence) => sentence.score === null
        );

        // 如果有未完成的句子，則計數加 1（一大題算一個任務）
        dailySpeechCount.value = hasIncomplete ? 1 : 0;

        console.log("Daily Speech 未完成任務數:", dailySpeechCount.value);
      } else {
        dailySpeechCount.value = 0;
      }
    }
  } catch (error) {
    console.error("獲取 Daily Speech 任務數量失敗:", error);
    dailySpeechCount.value = 0;
  }
};

// 獲取 AI Speech 任務數量
const getAISpeechCount = async () => {
  try {
    if (user.student && user.student.stuID) {
      const response = await ApiGetAISpeechList.get(
        user.student.stuID,
        "in_progress"
      );
      if (response.status === "success" && response.data) {
        aiSpeechCount.value = response.data.length;
      }
    }
  } catch (error) {
    console.error("獲取 AI Speech 任務數量失敗:", error);
    aiSpeechCount.value = 0;
  }
};

// 使用客製化配置的任務卡片
const taskCardItem = computed(() => {
  const filteredTasks = userCustomization.filteredTaskCards;

  // 將配置轉換為組件需要的格式
  return filteredTasks.map((task) => {
    const taskConfig = {
      title: t(task.title),
      bg:
        task.bg === "teacher"
          ? imgTeacher.value
          : task.bg === "moutain"
          ? imgMoutain.value
          : task.bg === "trophy"
          ? imgTrophy.value
          : imgTeacher.value,
      bgColor: task.bgColor,
      hint:
        task.hint === "totalAssignmentNum"
          ? user.hint.totalAssignmentNum
          : task.hint,
      link: task.link,
    };

    // 如果是 echo-valley (AI Speech)，使用 API 獲取的數量（包含 Daily Speech）
    if (task.title === "echo-valley") {
      const totalCount = aiSpeechCount.value + dailySpeechCount.value;
      taskConfig.hint = totalCount >= 0 ? totalCount : "";
    }

    return taskConfig;
  });
});

// 組件掛載時獲取 AI Speech 和 Daily Speech 數量
onMounted(() => {
  getAISpeechCount();
  getDailySpeechCount();
});

// 監聽用戶信息變化，重新獲取數量
watch(
  () => user.student?.stuID,
  (newStuID) => {
    if (newStuID) {
      getAISpeechCount();
      getDailySpeechCount();
    }
  }
);
</script>
<style lang="scss" scoped>
.min-card-height {
  min-height: 190px;
}

.b2c-min-card-height {
  min-height: 120px;
}
</style>
